import { createNode, InstantDataType, ZonedDateTimeDataType } from '@glueapp/graph-types';
import { toInstant, fromZonedDateTime } from '../../utils/temporal';

export const InstantToZonedDateTime = createNode({
    id: 'Instant to ZonedDateTime',
    name: 'Instant to ZonedDateTime',
    description: 'Converts an Instant to a ZonedDateTime in the specified timezone',
    aiDescription:
        'Takes an Instant on the "Instant" port and a timezone string on the "Timezone" port, and outputs a ZonedDateTime on the "ZonedDateTime" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Instant: InstantDataType,
        Timezone: { kind: 'string' },
    },
    outPorts: {
        ZonedDateTime: ZonedDateTimeDataType,
    },
    execute: function (input) {
        const instant = toInstant(input.inPorts.Instant);
        const zdt = instant.toZonedDateTimeISO(input.inPorts.Timezone);
        return { output: { ZonedDateTime: fromZonedDateTime(zdt) } };
    },
});
